"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _useAdvertPopup2 = require("@deosite/api/hooks/common/useAdvertPopup");
var _Dialog = _interopRequireDefault(require("@commerce-ui/core2/Dialog"));
var _Image = _interopRequireDefault(require("../Image"));
var _dialogImages = _interopRequireDefault(require("@deosite/mock-data/dialog-images"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Button = _interopRequireDefault(require("../buttons/Button"));
var _RouteContext = require("@deosite/lib/RouteContext");
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CloseIcon = function CloseIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.347 20.838l-15-15 .848-.848 15 15-.848.848z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.347 19.838l15-15 .848.849-15 15-.848-.849z"
  }));
};
CloseIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defautProps = {
  advertTextFont: "xl_sans",
  advertSloganFont: "l"
};
var NewsletterPopup = function NewsletterPopup(props) {
  var placement = props.placement,
    width = props.width,
    advertSlogan = props.advertSlogan,
    advertText = props.advertText,
    buttonLabel = props.buttonLabel,
    advertLink = props.advertLink,
    _props$advertTextFont = props.advertTextFont,
    advertTextFont = _props$advertTextFont === void 0 ? defautProps.advertTextFont : _props$advertTextFont,
    _props$advertSloganFo = props.advertSloganFont,
    advertSloganFont = _props$advertSloganFo === void 0 ? defautProps.advertSloganFont : _props$advertSloganFo;
  var _useAdvertPopup = (0, _useAdvertPopup2.useAdvertPopup)(),
    popupVisible = _useAdvertPopup.popupVisible,
    killPopup = _useAdvertPopup.killPopup;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Dialog["default"], {
    isOpen: popupVisible,
    anchoredTo: "window",
    sx: {
      width: ["90vw", null, null, width],
      placement: ["center", null, placement],
      overflow: "scroll",
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      background: "white",
      display: "flex",
      flexDirection: ["column", null, null, "row"]
    }
  }, __jsx(_Box["default"], {
    sx: {
      flex: "50%"
    }
  }, __jsx(_Image["default"], {
    image: _objectSpread(_objectSpread({}, _dialogImages["default"]), {}, {
      blurhash: "LFNv.3;4JCJ.,.8wD4~qD$%2$lRP"
    }),
    mode: "cover",
    sizes: "100vw"
  })), __jsx(_Box["default"], {
    sx: {
      flex: "50%",
      p: "s8",
      textAlign: "center",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      cursor: "pointer",
      "float": "right",
      position: ["absolute", null, null, "static"],
      right: 20,
      top: 20
    }
  }, __jsx(CloseIcon, {
    onClick: function onClick() {
      return killPopup();
    }
  })), advertSlogan && __jsx(_Box["default"], {
    sx: {
      font: advertSloganFont,
      mt: ["s6", null, null, "s10"]
    }
  }, advertSlogan), advertText && __jsx(_Box["default"], {
    sx: {
      font: advertTextFont,
      mt: "s7"
    }
  }, advertText), __jsx(Link, {
    href: advertLink
  }, __jsx(_Box["default"], {
    sx: {
      px: "s6",
      mt: ["s8", null, null, "s11"]
    }
  }, __jsx(_Button["default"], {
    sx: {
      width: ["unset", null, null, "100%"],
      height: 40,
      minWidth: 235,
      $secondFont: true
    },
    onClick: function onClick() {
      return killPopup();
    }
  }, buttonLabel))))));
};
var _default = NewsletterPopup;
exports["default"] = _default;